import yuanSvgUrl from '@/assets/img/icon/yuan.svg';
import fangSvgUrl from '@/assets/img/icon/fang.svg';

type CloseButtonBgMode = 'none' | 'circle' | 'square';

const svgCache: Partial<Record<CloseButtonBgMode, string>> = {};
let preloadPromise: Promise<void> | null = null;

function normalizeSvg(svg: string) {
  return svg
    .replace(/\swidth="[^"]*"/, ' width="100%"')
    .replace(/\sheight="[^"]*"/, ' height="100%"');
}

async function loadSvg(url: string) {
  const response = await fetch(url);
  return normalizeSvg(await response.text());
}

export function preloadCloseButtonSvg() {
  if (!preloadPromise) {
    preloadPromise = Promise.all([
      loadSvg(yuanSvgUrl).then((svg) => {
        svgCache.circle = svg;
        svgCache.none = svg;
      }),
      loadSvg(fangSvgUrl).then((svg) => {
        svgCache.square = svg;
      }),
    ]).then(() => undefined);
  }

  return preloadPromise;
}

export function getCloseButtonSvg(bgMode: CloseButtonBgMode = 'none') {
  if (bgMode === 'square') {
    return svgCache.square || '';
  }

  return svgCache.circle || svgCache.none || '';
}
